import React from 'react';
import { Card } from 'react-bootstrap';
import Plot from 'react-plotly.js';
import { TrendingUp } from 'lucide-react';

const TrendsChart = ({ chartData }) => {
  if (!chartData) return null;

  try {
    const plotData = JSON.parse(chartData);
    
    return (
      <Card>
        <Card.Header>
          <h5 className="card-title mb-0 d-flex align-items-center">
            <TrendingUp className="text-primary me-2" size={20} />
            Google Trends: Singapore PR Search Interest
          </h5>
        </Card.Header>
        <Card.Body>
          <div className="chart-container">
            <Plot
              data={plotData.data}
              layout={{
                ...plotData.layout,
                autosize: true,
                responsive: true,
              }}
              config={{
                responsive: true,
                displayModeBar: true,
                displaylogo: false,
                modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d']
              }}
              style={{ width: '100%', height: '500px' }}
            />
          </div>
        </Card.Body>
      </Card>
    );
  } catch (error) {
    console.error('Error rendering trends chart:', error);
    return (
      <Card>
        <Card.Header>
          <h5 className="card-title mb-0">
            <TrendingUp className="text-primary me-2" size={20} />
            Google Trends: Singapore PR Search Interest
          </h5>
        </Card.Header>
        <Card.Body>
          <div className="alert alert-danger">
            Error loading chart data. Please try refreshing the page.
          </div>
        </Card.Body>
      </Card>
    );
  }
};

export default TrendsChart;